// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const goalSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  name: z.string().max(500).optional(),
  title: z.string().max(500),
  description: z.string().max(100000).optional(),
  status: z.string().max(50),
  priority: z.string().max(50),
  category: z.string().max(200).optional(),
  progressMode: z.string().max(200).optional(),
  currentProgress: z.number().min(0).max(100).optional(),
  completed: z.boolean(),
  dueDate: z.string().max(200).optional(),
  targetDate: z.string().max(200).optional(),
  parentGoalId: z.string().max(100).optional(),
  metrics: z.array(z.unknown()).optional(),
  archived: z.boolean(),
  tenantId: z.string().max(100).optional(),
})

export type GoalInput = z.infer<typeof goalSchema>
